import type { PropsWithChildren } from 'react';
import type React from 'react';
import { styled } from 'styled-components';

import { Media } from '../../theme/Media.tsx';

const Wrapper = styled.div<{ $withReset?: boolean }>`
  @media ${Media.smMin} {
    flex: 0 0 290px;
  }
  position: relative;
`;

export interface ISearch extends PropsWithChildren {
  dataTestId?: string;
}

const Search: React.FC<ISearch> = ({ children, dataTestId }) => <Wrapper data-testid={dataTestId}>{children}</Wrapper>;

export default Search;
